import { tVariants } from '../../style-system';

export const proseStyles = tVariants({
    base: 'prose min-w-full',
    variants: {
        variant: {
            primary: 'prose-primary',
        },
        size: {
            sm: 'prose-sm',
            md: 'prose-base',
        },
    },
});
